export default __webpack_public_path__ + "static/media/eye-icon.98383dc6.svg";